import { Copytext } from '@/app/_components/core/copytext';
import { getDescriptionClampClass } from '@/app/_components/shared/event-card/event-card.variants';
import type { CardVariant } from '@/app/_components/shared/event-card/event-card.variants';
import { cn } from '@/app/_lib/utils';

export interface CardDescriptionProps {
  description: string;
  variant: CardVariant;
}

export function CardDescription({
  description,
  variant,
}: CardDescriptionProps) {
  return (
    <Copytext
      variant="muted"
      className={cn('font-normal', getDescriptionClampClass(variant))}
    >
      {description}
    </Copytext>
  );
}
